<template>
	<lee-page code="supplyDemand" bg-img="/images/banner/3.jpg" title="供需" titleClass="margin-top-200 light f70" sub-title="Industry Data" height="528" des="" :bread="[{title:'供需'}]">
		<div class="bg-img-5">
			<div class="wrap1100 margin-top-100 margin-auto padding-bottom-100">
				<el-row :gutter="100">
					<el-col :span="12">
						<div class="box-shadow hover-cell border-radius-5 hide rel hand" style="height: 450px;background: url('/images/bg_cell_1.jpg') no-repeat top right;background-size: 100% 100%;" @click="$router.push({path:'/supplyDemand/list/supply'})">
							<div class="abs bg-light border-radius-5 block hover-hide" style="height:100px;bottom:0;left:0;padding:20px 30px;line-height: 60px;">
								<div class="cl">
									<lee-img-icon url="/images/icon/icon_18.png" size="60" class="z" color="#eee"></lee-img-icon>
									<span class="z f24 dark-2 margin-left-20 f-lq" style="vertical-align: middle;">供应</span>
									<i class="el-icon-right y green f24" style="margin-top:18px;"></i>
								</div>
							</div>
							<div class="text-center padding-top-100 bg-green-op abs hover-show" style="top:0;left:0;right:0;bottom:0;">
								<lee-img-icon url="/images/icon/icon_18.png" size="120" color="#fff"></lee-img-icon>
								<div class="f-lq f24 light margin-top-30">供应</div>
								<div class="text-center margin-top-30"><i class="f24 el-icon-right light"></i></div>
							</div>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="box-shadow hover-cell border-radius-5 hide rel hand" style="height: 450px;background: url('/images/bg_cell_2.jpg') no-repeat top right;background-size: 100% 100%;" @click="$router.push({path:'/supplyDemand/list/demand'})">
							<div class="abs bg-light border-radius-5 block hover-hide" style="height:100px;bottom:0;left:0;padding:20px 30px;line-height: 60px;">
								<div class="cl">
									<lee-img-icon url="/images/icon/icon_18.png" size="60" class="z" color="#eee"></lee-img-icon>
									<span class="z f24 dark-2 margin-left-20 f-lq" style="vertical-align: middle;">需求</span>
									<i class="el-icon-right y green f24" style="margin-top:18px;"></i>
								</div>
							</div>
							<div class="text-center padding-top-100 bg-green-op abs hover-show" style="top:0;left:0;right:0;bottom:0;">
								<lee-img-icon url="/images/icon/icon_18_1.png" size="120" color="#fff"></lee-img-icon>
								<div class="f-lq f24 light margin-top-30">需求</div>
								<div class="text-center margin-top-30"><i class="f24 el-icon-right light"></i></div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</lee-page>
</template>

<script>
export default {
	name: "Index",
	data() {
		return {
			list: [],
			searchForm:{
				akey:'supply',
				pid:'0',
				state:1,
				orderBy:'sort',
				sortBy:'asc'
			},
			totalCount:0
		}
	},
	mounted() {
		this.getList();
		this.$utils.addSystemTotal('module','supplyDemand','供需');
	},
	methods: {
		getList(){
			let _this = this;

			this.$http.post({
				url:'/Type/listAll',
				data:this.searchForm,
				success(res){
					_this.list = res;
				}
			})
		}
	}
}
</script>
